
import { Widgets } from "@mui/icons-material";
import DashboardCommanDt from "./DashboardCommanDt";

export function TotalValueDt() {
  const columns = [
    { field: "id", headerName: "Sr No" },
    { field: "amount", headerName: "Amount" },
  ];

  const rows = [
    { id: 1, code: "Demo", amount: 50 },
    { id: 2, code: "Demo2", amount: 20 },
  ];
  return (
    <DashboardCommanDt  title="Total Value"    icon={<Widgets sx={{ mr: 1 }} />}  columns={columns} rows={rows} />
   );
}



